import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

// icons

// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Footer from "components/Footer/Footer.jsx";

// styles
import http404PageStyle from "assets/jss/material-kit-react/views/defaultPage.jsx";

// Sections for this page
import SectionError from "./Sections/sectionError.jsx";
import SectionContact from "../ContactPage/Sections/sectionContact.jsx";

const dashboardRoutes = [];

class Http404Page extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="Finwe Ltd."
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 150,
            color: "white"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/default_background.jpg")} small>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <h1 className={classes.title}>HTTP 404 - Page not found</h1>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <SectionError />
            <SectionContact />
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default withStyles(http404PageStyle)(Http404Page);
